import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon } from 'rsuite';

const widthBySize = { xs: 400, sm: 600, md: 800, lg: 968 };
const autoWidthStyle = size => ({
  margin: '20px auto',
  padding: '0 5px',
  width: 'auto',
  maxWidth: widthBySize[size]
});

export default class DeleteConfirmationModal extends React.Component {
  static propTypes = {
    message: PropTypes.string,
    size: PropTypes.string,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    isDeleting: PropTypes.bool.isRequired,
    mobileSupport: PropTypes.bool
  };

  static defaultProps = {
    message: '',
    size: 'xs',
    mobileSupport: false
  };

  render() {
    const {
      size,
      show,
      onHide,
      onConfirm,
      isDeleting,
      message,
      mobileSupport
    } = this.props;

    return (
      <Modal
        backdrop="static"
        show={show}
        onHide={this.onHide}
        size={size}
        {...(mobileSupport ? { style: autoWidthStyle(size) } : {})}
      >
        <Modal.Body>
          <Icon icon="exclamation-circle" style={{ color: '#f44336' }} />
          &nbsp; {message || 'Are you sure you want to delete it?'}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={onConfirm}
            appearance="primary"
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Yes'}
          </Button>
          <Button onClick={onHide} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
